// components/HelpPage.js - Page d'aide et documentation
import React, { useState, useMemo } from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { Home, HelpCircle, BookOpen, MessageCircle, Mail } from 'lucide-react';

const HelpPage = ({ onNavigate }) => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState('faq');

  const faqSections = useMemo(() => [
    {
      title: t('help.faq_attendance_title'),
      icon: '⏰',
      description: t('help.faq_attendance_desc'),
      questions: [
        { q: t('help.faq_attendance_q1'), a: t('help.faq_attendance_a1') },
        { q: t('help.faq_attendance_q2'), a: t('help.faq_attendance_a2') },
        { q: t('help.faq_attendance_q3'), a: t('help.faq_attendance_a3') },
        { q: t('help.faq_attendance_q4'), a: t('help.faq_attendance_a4') },
        { q: t('help.faq_attendance_q5'), a: t('help.faq_attendance_a5') }
      ]
    },
    {
      title: t('help.faq_history_title'),
      icon: '📋',
      description: t('help.faq_history_desc'),
      questions: [
        { q: t('help.faq_history_q1'), a: t('help.faq_history_a1') },
        { q: t('help.faq_history_q2'), a: t('help.faq_history_a2') },
        { q: t('help.faq_history_q3'), a: t('help.faq_history_a3') }
      ]
    },
    {
      title: t('help.faq_reports_title'),
      icon: '📊',
      description: t('help.faq_reports_desc'),
      questions: [
        { q: t('help.faq_reports_q1'), a: t('help.faq_reports_a1') },
        { q: t('help.faq_reports_q2'), a: t('help.faq_reports_a2') },
        { q: t('help.faq_reports_q3'), a: t('help.faq_reports_a3') }
      ]
    },
    {
      title: t('help.faq_leaves_title'),
      icon: '🏖️',
      description: t('help.faq_leaves_desc'),
      questions: [
        { q: t('help.faq_leaves_q1'), a: t('help.faq_leaves_a1') },
        { q: t('help.faq_leaves_q2'), a: t('help.faq_leaves_a2') },
        { q: t('help.faq_leaves_q3'), a: t('help.faq_leaves_a3') },
        { q: t('help.faq_leaves_q4'), a: t('help.faq_leaves_a4') },
        { q: t('help.faq_leaves_q5'), a: t('help.faq_leaves_a5') }
      ]
    },
    {
      title: t('help.faq_balances_title'),
      icon: '💰',
      description: t('help.faq_balances_desc'),
      questions: [
        { q: t('help.faq_balances_q1'), a: t('help.faq_balances_a1') },
        { q: t('help.faq_balances_q2'), a: t('help.faq_balances_a2') },
        { q: t('help.faq_balances_q3'), a: t('help.faq_balances_a3') },
        { q: t('help.faq_balances_q4'), a: t('help.faq_balances_a4') }
      ]
    },
    {
      title: t('help.faq_dashboard_title'),
      icon: '📊',
      description: t('help.faq_dashboard_desc'),
      questions: [
        { q: t('help.faq_dashboard_q1'), a: t('help.faq_dashboard_a1') },
        { q: t('help.faq_dashboard_q2'), a: t('help.faq_dashboard_a2') },
        { q: t('help.faq_dashboard_q3'), a: t('help.faq_dashboard_a3') },
        { q: t('help.faq_dashboard_q4'), a: t('help.faq_dashboard_a4') }
      ]
    },
    {
      title: t('help.faq_messages_title'),
      icon: '💬',
      description: t('help.faq_messages_desc'),
      questions: [
        { q: t('help.faq_messages_q1'), a: t('help.faq_messages_a1') },
        { q: t('help.faq_messages_q2'), a: t('help.faq_messages_a2') },
        { q: t('help.faq_messages_q3'), a: t('help.faq_messages_a3') },
        { q: t('help.faq_messages_q4'), a: t('help.faq_messages_a4') }
      ]
    },
    {
      title: t('help.faq_formations_title'),
      icon: '🎓',
      description: t('help.faq_formations_desc'),
      questions: [
        { q: t('help.faq_formations_q1'), a: t('help.faq_formations_a1') },
        { q: t('help.faq_formations_q2'), a: t('help.faq_formations_a2') },
        { q: t('help.faq_formations_q3'), a: t('help.faq_formations_a3') },
        { q: t('help.faq_formations_q4'), a: t('help.faq_formations_a4') }
      ]
    },
    {
      title: t('help.faq_expenses_title'),
      icon: '💰',
      description: t('help.faq_expenses_desc'),
      questions: [
        { q: t('help.faq_expenses_q1'), a: t('help.faq_expenses_a1') },
        { q: t('help.faq_expenses_q2'), a: t('help.faq_expenses_a2') },
        { q: t('help.faq_expenses_q3'), a: t('help.faq_expenses_a3') },
        { q: t('help.faq_expenses_q4'), a: t('help.faq_expenses_a4') },
        { q: t('help.faq_expenses_q5'), a: t('help.faq_expenses_a5') },
        { q: t('help.faq_expenses_q6'), a: t('help.faq_expenses_a6') }
      ]
    },
    {
      title: t('help.faq_team_title'),
      icon: '👥',
      description: t('help.faq_team_desc'),
      questions: [
        { q: t('help.faq_team_q1'), a: t('help.faq_team_a1') },
        { q: t('help.faq_team_q2'), a: t('help.faq_team_a2') },
        { q: t('help.faq_team_q3'), a: t('help.faq_team_a3') },
        { q: t('help.faq_team_q4'), a: t('help.faq_team_a4') },
        { q: t('help.faq_team_q5'), a: t('help.faq_team_a5') }
      ]
    },
    {
      title: t('help.faq_badges_title'),
      icon: '🔖',
      description: t('help.faq_badges_desc'),
      questions: [
        { q: t('help.faq_badges_q1'), a: t('help.faq_badges_a1') },
        { q: t('help.faq_badges_q2'), a: t('help.faq_badges_a2') },
        { q: t('help.faq_badges_q3'), a: t('help.faq_badges_a3') },
        { q: t('help.faq_badges_q4'), a: t('help.faq_badges_a4') },
        { q: t('help.faq_badges_q5'), a: t('help.faq_badges_a5') }
      ]
    },
    {
      title: t('help.faq_documents_title'),
      icon: '📄',
      description: t('help.faq_documents_desc'),
      questions: [
        { q: t('help.faq_documents_q1'), a: t('help.faq_documents_a1') },
        { q: t('help.faq_documents_q2'), a: t('help.faq_documents_a2') },
        { q: t('help.faq_documents_q3'), a: t('help.faq_documents_a3') },
        { q: t('help.faq_documents_q4'), a: t('help.faq_documents_a4') },
        { q: t('help.faq_documents_q5'), a: t('help.faq_documents_a5') },
        { q: t('help.faq_documents_q6'), a: t('help.faq_documents_a6') }
      ]
    },
    {
      title: t('help.faq_profile_title'),
      icon: '👤',
      description: t('help.faq_profile_desc'),
      questions: [
        { q: t('help.faq_profile_q1'), a: t('help.faq_profile_a1') },
        { q: t('help.faq_profile_q2'), a: t('help.faq_profile_a2') },
        { q: t('help.faq_profile_q3'), a: t('help.faq_profile_a3') },
        { q: t('help.faq_profile_q4'), a: t('help.faq_profile_a4') },
        { q: t('help.faq_profile_q5'), a: t('help.faq_profile_a5') },
        { q: t('help.faq_profile_q6'), a: t('help.faq_profile_a6') }
      ]
    },
    {
      title: t('help.faq_audit_title'),
      icon: '📸',
      description: t('help.faq_audit_desc'),
      questions: [
        { q: t('help.faq_audit_q1'), a: t('help.faq_audit_a1') },
        { q: t('help.faq_audit_q2'), a: t('help.faq_audit_a2') },
        { q: t('help.faq_audit_q3'), a: t('help.faq_audit_a3') },
        { q: t('help.faq_audit_q4'), a: t('help.faq_audit_a4') }
      ]
    },
    {
      title: t('help.faq_billing_title'),
      icon: '💳',
      description: t('help.faq_billing_desc'),
      questions: [
        { q: t('help.faq_billing_q1'), a: t('help.faq_billing_a1') },
        { q: t('help.faq_billing_q2'), a: t('help.faq_billing_a2') },
        { q: t('help.faq_billing_q3'), a: t('help.faq_billing_a3') },
        { q: t('help.faq_billing_q4'), a: t('help.faq_billing_a4') },
        { q: t('help.faq_billing_q5'), a: t('help.faq_billing_a5') }
      ]
    },
    {
      title: t('help.faq_plans_title'),
      icon: '📋',
      description: t('help.faq_plans_desc'),
      questions: [
        { q: t('help.faq_plans_q1'), a: t('help.faq_plans_a1') },
        { q: t('help.faq_plans_q2'), a: t('help.faq_plans_a2') },
        { q: t('help.faq_plans_q3'), a: t('help.faq_plans_a3') },
        { q: t('help.faq_plans_q4'), a: t('help.faq_plans_a4') },
        { q: t('help.faq_plans_q5'), a: t('help.faq_plans_a5') },
        { q: t('help.faq_plans_q6'), a: t('help.faq_plans_a6') }
      ]
    }
  ], [t]);

  const quickGuides = useMemo(() => [
    {
      title: t('help.guides_getting_started_title'),
      icon: '🚀',
      content: [
        t('help.guides_getting_started_1'),
        t('help.guides_getting_started_2'),
        t('help.guides_getting_started_3'),
        t('help.guides_getting_started_4'),
        t('help.guides_getting_started_5'),
        t('help.guides_getting_started_6')
      ]
    },
    {
      title: t('help.guides_daily_attendance_title'),
      icon: '⏰',
      content: [
        t('help.guides_daily_attendance_1'),
        t('help.guides_daily_attendance_2'),
        t('help.guides_daily_attendance_3'),
        t('help.guides_daily_attendance_4'),
        t('help.guides_daily_attendance_5'),
        t('help.guides_daily_attendance_6'),
        t('help.guides_daily_attendance_7')
      ]
    },
    {
      title: t('help.guides_request_leave_title'),
      icon: '🏖️',
      content: [
        t('help.guides_request_leave_1'),
        t('help.guides_request_leave_2'),
        t('help.guides_request_leave_3'),
        t('help.guides_request_leave_4'),
        t('help.guides_request_leave_5'),
        t('help.guides_request_leave_6'),
        t('help.guides_request_leave_7'),
        t('help.guides_request_leave_8')
      ]
    },
    {
      title: t('help.guides_expense_report_title'),
      icon: '💰',
      content: [
        t('help.guides_expense_report_1'),
        t('help.guides_expense_report_2'),
        t('help.guides_expense_report_3'),
        t('help.guides_expense_report_4'),
        t('help.guides_expense_report_5'),
        t('help.guides_expense_report_6'),
        t('help.guides_expense_report_7'),
        t('help.guides_expense_report_8')
      ]
    },
    {
      title: t('help.guides_add_employee_title'),
      icon: '👥',
      content: [
        t('help.guides_add_employee_1'),
        t('help.guides_add_employee_2'),
        t('help.guides_add_employee_3'),
        t('help.guides_add_employee_4'),
        t('help.guides_add_employee_5'),
        t('help.guides_add_employee_6'),
        t('help.guides_add_employee_7'),
        t('help.guides_add_employee_8')
      ]
    },
    {
      title: t('help.guides_generate_badge_title'),
      icon: '🔖',
      content: [
        t('help.guides_generate_badge_1'),
        t('help.guides_generate_badge_2'),
        t('help.guides_generate_badge_3'),
        t('help.guides_generate_badge_4'),
        t('help.guides_generate_badge_5'),
        t('help.guides_generate_badge_6'),
        t('help.guides_generate_badge_7')
      ]
    },
    {
      title: t('help.guides_upload_document_title'),
      icon: '📄',
      content: [
        t('help.guides_upload_document_1'),
        t('help.guides_upload_document_2'),
        t('help.guides_upload_document_3'),
        t('help.guides_upload_document_4'),
        t('help.guides_upload_document_5'),
        t('help.guides_upload_document_6'),
        t('help.guides_upload_document_7'),
        t('help.guides_upload_document_8')
      ]
    },
    {
      title: t('help.guides_generate_report_title'),
      icon: '📊',
      content: [
        t('help.guides_generate_report_1'),
        t('help.guides_generate_report_2'),
        t('help.guides_generate_report_3'),
        t('help.guides_generate_report_4'),
        t('help.guides_generate_report_5'),
        t('help.guides_generate_report_6'),
        t('help.guides_generate_report_7'),
        t('help.guides_generate_report_8')
      ]
    }
  ], [t]);

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      background: 'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%)',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
      overflowX: 'hidden',
      paddingBottom: 'env(safe-area-inset-bottom, 0)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: 'auto'
    }}>
      {/* Header transparent */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        padding: '24px 20px 20px',
        background: 'transparent',
        backdropFilter: 'none',
        borderBottom: 'none',
        zIndex: 999,
        maxWidth: '100%'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start',
          marginBottom: '6px',
          gap: '16px'
        }}>
          {onNavigate && (
            <button
              onClick={() => onNavigate('home')}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: '#ffffff',
                padding: '10px',
                borderRadius: '12px',
                fontSize: '18px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                backdropFilter: 'blur(10px)',
                flexShrink: 0,
                width: '44px',
                height: '44px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.transform = 'scale(1)';
              }}
              title={t('help.back_to_home')}
            >
              <Home size={20} />
            </button>
          )}
          <div style={{ 
            fontSize: 'clamp(28px, 5vw, 40px)', 
            fontWeight: 700, 
            maxWidth: '100%',
            letterSpacing: '-0.5px',
            lineHeight: 1.2,
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <HelpCircle size={32} />
            {t('help.title')}
          </div>
        </div>
        <p style={{
          fontSize: 'clamp(14px, 2vw, 16px)',
          color: 'rgba(255, 255, 255, 0.7)',
          margin: '8px 0 0 0',
          letterSpacing: '0.2px',
          fontWeight: 500
        }}>
          {t('help.subtitle')}
        </p>
      </div>

      {/* Contenu principal */}
      <div className="help-content" style={{
        paddingTop: '140px',
        paddingBottom: '40px',
        paddingLeft: '20px',
        paddingRight: '20px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>

      {/* Navigation */}
      <div style={{
        display: 'flex',
        gap: '12px',
        marginBottom: '24px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        <button
          onClick={() => setActiveSection('faq')}
          style={{
            padding: '12px 24px',
            background: activeSection === 'faq'
              ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
              : 'rgba(255, 255, 255, 0.1)',
            color: '#ffffff',
            border: 'none',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: activeSection === 'faq' ? '0 4px 16px rgba(59, 130, 246, 0.3)' : 'none'
          }}
        >
          <HelpCircle size={18} />
          {t('help.nav_faq')}
        </button>
        <button
          onClick={() => setActiveSection('guides')}
          style={{
            padding: '12px 24px',
            background: activeSection === 'guides'
              ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
              : 'rgba(255, 255, 255, 0.1)',
            color: '#ffffff',
            border: 'none',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: activeSection === 'guides' ? '0 4px 16px rgba(59, 130, 246, 0.3)' : 'none'
          }}
        >
          <BookOpen size={18} />
          {t('help.nav_guides')}
        </button>
        <button
          onClick={() => setActiveSection('contact')}
          style={{
            padding: '12px 24px',
            background: activeSection === 'contact'
              ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
              : 'rgba(255, 255, 255, 0.1)',
            color: '#ffffff',
            border: 'none',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: activeSection === 'contact' ? '0 4px 16px rgba(59, 130, 246, 0.3)' : 'none'
          }}
        >
          <Mail size={18} />
          {t('help.nav_contact')}
        </button>
      </div>

      {/* FAQ Section */}
      {activeSection === 'faq' && (
        <div>
          {faqSections.map((section, idx) => (
            <div key={idx} style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '15px',
              padding: '30px',
              marginBottom: '24px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '12px'
              }}>
                <span style={{ fontSize: '32px' }}>{section.icon}</span>
                <div>
                  <h2 style={{ 
                    color: '#14b8a6', 
                    margin: 0, 
                    fontSize: '24px',
                    fontWeight: 700
                  }}>
                    {section.title}
                  </h2>
                  {section.description && (
                    <p style={{
                      color: 'rgba(255, 255, 255, 0.6)',
                      fontSize: '14px',
                      margin: '4px 0 0 0'
                    }}>
                      {section.description}
                    </p>
                  )}
                </div>
              </div>
              <div style={{
                marginTop: '20px',
                paddingTop: '20px',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                {section.questions.map((item, qIdx) => (
                  <div key={qIdx} style={{ 
                    marginBottom: '20px',
                    padding: '16px',
                    background: 'rgba(255, 255, 255, 0.03)',
                    borderRadius: '10px'
                  }}>
                    <div style={{
                      color: '#14b8a6',
                      fontWeight: 600,
                      marginBottom: '8px',
                      fontSize: '16px',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '8px'
                    }}>
                      <span style={{ color: '#3b82f6' }}>❓</span>
                      <span>{item.q}</span>
                    </div>
                    <div style={{
                      color: '#94a3b8',
                      lineHeight: '1.7',
                      paddingLeft: '28px',
                      fontSize: '15px'
                    }}>
                      {item.a}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Quick Guides */}
      {activeSection === 'guides' && (
        <div>
          {quickGuides.map((guide, idx) => (
            <div key={idx} style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '15px',
              padding: '30px',
              marginBottom: '24px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '20px'
              }}>
                <span style={{ fontSize: '32px' }}>{guide.icon}</span>
                <h2 style={{ 
                  color: '#14b8a6', 
                  margin: 0, 
                  fontSize: '24px',
                  fontWeight: 700
                }}>
                  {guide.title}
                </h2>
              </div>
              <ol style={{ 
                listStyle: 'none', 
                padding: 0,
                margin: 0
              }}>
                {guide.content.map((step, sIdx) => (
                  <li key={sIdx} style={{
                    color: '#94a3b8',
                    marginBottom: '14px',
                    paddingLeft: '40px',
                    lineHeight: '1.7',
                    fontSize: '15px',
                    position: 'relative'
                  }}>
                    <div style={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                      color: 'white',
                      width: '28px',
                      height: '28px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 600,
                      fontSize: '14px',
                      flexShrink: 0
                    }}>
                      {sIdx + 1}
                    </div>
                    <span>{step}</span>
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      )}

      {/* Contact Support */}
      {activeSection === 'contact' && (
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          borderRadius: '15px',
          padding: '40px',
          backdropFilter: 'blur(10px)',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#14b8a6', marginBottom: '30px', fontSize: '28px' }}>
            {t('help.contact_title')}
          </h2>
          <div style={{ color: '#94a3b8', lineHeight: '1.8', fontSize: '16px' }}>
            <p style={{ marginBottom: '20px' }}>
              {t('help.contact_text')}
            </p>
            <div style={{
              background: 'rgba(20, 184, 166, 0.1)',
              padding: '20px',
              borderRadius: '10px',
              marginTop: '30px'
            }}>
              <p style={{ fontWeight: 'bold', color: '#14b8a6', marginBottom: '10px' }}>
                {t('help.contact_admin_title')}
              </p>
              <p style={{ color: '#94a3b8' }}>
                {t('help.contact_admin_text')}
              </p>
            </div>
          </div>
        </div>
      )}
      </div>

      {/* CSS pour animations */}
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @media (min-width: 768px) {
          .help-content {
            padding: 160px 40px 40px !important;
          }
        }
        @media (min-width: 1024px) {
          .help-content {
            padding: 180px 60px 60px !important;
          }
        }
        .help-content {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default HelpPage;

